import { createAction, props } from '@ngrx/store';

import { FeedAdvice, FeedAdviceType } from '../models/feed-advice.model';
import { UpsertFeedAdviceResponse } from '../services/feed-advice-service.model';

export const loadData = createAction('[FeedAdvice] Load data');
export const clearFeedAdviceState = createAction('[FeedAdvice] Clear feedAdvice state');

/*** LOAD FEEDADVICES ***/
export const loadFeedAdvicesRequest = createAction('[FeedAdvice] Load FeedAdvices Request');
export const loadReferenceFeedAdvicesRequest = createAction(
  '[ReferenceFeedAdvice] Load ReferenceFeedAdvices Request',
);
export const loadFeedAdvicesSuccess = createAction(
  '[FeedAdvice] Load FeedAdvices Success',
  props<{ feedAdvices: FeedAdvice[] }>(),
);
export const loadFeedAdvicesError = createAction(
  '[FeedAdvice] Load FeedAdvices Error',
  props<{ error: Error }>(),
);
export const loadSelectedFeedAdvice = createAction('[FeedAdvice] Load selected FeedAdvice');

/* SET FEEDADVICE */
export const setSelectedFeedAdviceFromReference = createAction(
  '[FeedAdvice] Set Selected FeedAdvice From Reference',
  props<{ feedAdvice: FeedAdvice }>(),
);
export const setSelectedFeedAdviceSuccess = createAction(
  '[FeedAdvice] Set Selected FeedAdvice Success',
  props<{ feedAdviceId: number }>(),
);
export const setLocationsForFeedAdvice = createAction(
  '[FeedAdvice] Set Locations For FeedAdvice',
  props<{ locations: number[] }>(),
);

/*** UPSERT  ***/
export const upsertFeedAdviceRequest = createAction(
  '[FeedAdvice] Upsert FeedAdvice Request',
  props<{ request: FeedAdvice; isReferenceFeedAdvice: boolean }>(),
);
export const upsertFeedAdviceSuccess = createAction(
  '[FeedAdvice] Upsert FeedAdvice Success',
  props<{ response: UpsertFeedAdviceResponse; savedAdvice: FeedAdvice }>(),
);
export const upsertReferenceFeedAdviceSuccess = createAction(
  '[FeedAdvice] Upsert Reference FeedAdvice Success',
  props<{ response: UpsertFeedAdviceResponse; savedAdvice: FeedAdvice }>(),
);
export const upsertFeedAdviceError = createAction(
  '[FeedAdvice] Upsert FeedAdvice Error',
  props<{ error: Error }>(),
);

/*** DELETE ***/
export const deleteFeedAdviceRequest = createAction(
  '[FeedAdvice] Delete feedadvice request',
  props<{ feedAdviceId: number; isReferenceFeedAdvice: boolean }>(),
);
export const deleteFeedAdviceWithConfirmation = createAction(
  '[FeedAdvice] Confirm Delete feedadvice',
  props<{ feedAdviceId: number; isReferenceFeedAdvice: boolean }>(),
);
export const deleteFeedAdviceSuccess = createAction(
  '[FeedAdvice] Delete feedadvice success',
  props<{ feedAdviceId: number; isReferenceFeedAdvice: boolean }>(),
);

/*** COUNTRY ***/
export const setSelectedCountry = createAction(
  '[ReferenceFeedAdvice] Set selected country',
  props<{ save: boolean; id: string }>(),
);
export const setSelectedCountrySuccess = createAction(
  '[ReferenceFeedAdvice] Set selected country success',
  props<{ id: string }>(),
);
export const loadSelectedCountry = createAction('[ReferenceFeedAdvice] Load selected country');

/*** SHOW_LYSINE_SETTING ***/
export const setShowLysineSetting = createAction(
  '[FeedAdvice] Set Show Lysine Setting',
  props<{ save: boolean; showLysine: boolean }>(),
);
export const setShowLysineSettingSuccess = createAction(
  '[FeedAdvice] Set Show Lysine Setting success',
  props<{ showLysine: boolean }>(),
);
export const loadShowLysineSetting = createAction('[FeedAdvice] Load Show Lysine Setting');

/*** SHOW_ENERGY_SETTING ***/
export const setShowEnergySetting = createAction(
  '[FeedAdvice] Set Show Energy Setting',
  props<{ save: boolean; showEnergy: boolean }>(),
);
export const setShowEnergySettingSuccess = createAction(
  '[FeedAdvice] Set Show Energy Setting success',
  props<{ showEnergy: boolean }>(),
);
export const loadShowEnergySetting = createAction('[FeedAdvice] Load Show Energy Setting');

/*** SHOW_DOSATOR_SETTING ***/
export const setShowDosatorSetting = createAction(
  '[FeedAdvice] Set Show Dosator Setting',
  props<{ save: boolean; showDosator: boolean }>(),
);
export const setShowDosatorSettingSuccess = createAction(
  '[FeedAdvice] Set Show Dosator Setting success',
  props<{ showDosator: boolean }>(),
);
export const loadShowDosatorSetting = createAction('[FeedAdvice] Load Show Dosator Setting');

/*** FEEDADVICETYPES ***/
export const setSelectedFeedadviceTypes = createAction(
  '[ReferenceFeedAdvice] Set selected FeedadviceTypes',
  props<{ save: boolean; types: string[] }>(),
);
export const setSelectedFeedadviceTypesSuccess = createAction(
  '[ReferenceFeedAdvice] Set selected FeedadviceTypes success',
  props<{ types: string[] }>(),
);
export const loadSelectedFeedadviceTypes = createAction(
  '[ReferenceFeedAdvice] Load selected FeedadviceTypes',
);

/*** NAVIGATION ACTIONS ***/
export const navigateFeedAdviceDetail = createAction(
  '[FeedAdvice] Navigate to feedAdvice detail',
  props<{
    feedAdviceId: number;
    isReferenceFeedAdvice: boolean;
    mode: string;
    feedAdviceType: FeedAdviceType;
  }>(),
);
export const navigateSowsFeedAdviceDetail = createAction(
  '[FeedAdvice] Navigate to Sows feedAdvice detail',
  props<{
    feedAdviceId: number;
    isReferenceFeedAdvice: boolean;
    mode: string;
    feedAdviceType: FeedAdviceType;
  }>(),
);
export const navigateCreateFeedAdvice = createAction(
  '[FeedAdvice] Navigate to create feedAdvice',
  props<{ isReferenceFeedAdvice: boolean; feedAdviceType: FeedAdviceType }>(),
);
export const navigateFromReferenceRequest = createAction(
  '[FeedAdvice] Navigate to From Reference Selection Request',
  props<{ feedAdviceType: FeedAdviceType }>(),
);
export const navigateFromReferenceSuccess = createAction(
  '[FeedAdvice] Navigate to From Reference Selection Success',
  props<{ feedAdvicesFromReference: FeedAdvice[]; feedAdviceType: FeedAdviceType }>(),
);
